export default {
  agency_key: '',
  mode: '',
  chat_url: '',
  beian: '',
  beian_gn: '',

  address: '杭州临界密度信息技术有限公司',
  uc_host: 'http://www.jjjtcc.com',
  site_host: 'http://user.jjjtcc.com',
  special_url: '/',
  site_title: '媒体通-软文精准营销平台',
  welcome_title: '媒体通 — 软文精准营销平台！',
  site_short_title: '媒体通',
  site_subtitle: '软文精准营销平台',
  company_name: '杭州临界密度信息技术有限公司',
  copyright: '© 2026 杭州临界密度信息技术有限公司',
  logo: 'https://fagao.oss-cn-shanghai.aliyuncs.com/uploads/190/260412/f89a2a50cd9d2ec770321f3d04cac511.png',
  favicon: 'https://fagao.oss-cn-shanghai.aliyuncs.com/uploads/190/260412/481533d69a2f0f91983ba94a8e6f803c.ico',
  payment: '',
  qq: '203392923',
  tel: '15136135595',
  company_account_id: '',
  company_bank: '',
  company_bank_name: '',
  alipay_account_id: '',
  alipay_name: '',
  alipay_pic: '',
  section_id: 5336007,
  belonger_id: 5336007,
}



//////////////////
// WEBPACK FOOTER
// ./project_config.js
// module id = null
// module chunks = 